export default "/images/el-lizard-birth-button.png?7aff06eef0c891624a8adeb0cd1a9c78";